import Icon from '../../components/Icon.vue'

Icon.register({"regular/paper-plane":{"width":512,"height":512,"paths":[{"d":"M440 6.5L24 246.4C-10.4 266.3-7.1 317.2 29.7 332.3L144 379.6V464C144 510.4 203.2 529.5 230.6 492.6L274.4 433.5 386.3 479.7C392.2 482.1 398.4 483.3 404.6 483.3 412.8 483.3 420.9 481.2 428.2 477.1 441 469.9 449.8 457.1 452.1 442.6L511.5 55.4C517.6 15.3 474.6-13.4 440 6.5zM192 464V399.4L228.6 414.5 192 464zM404.6 435.3L250.8 371.8 391 169.5C401.7 154 381.5 136 367.3 148.3L155.8 332.6 48 288 464 48 404.6 435.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/paper-plane.js
// module id = w1Ea
// module chunks = 0